import * as marietta from '../..';
import { EventDispatcher, Event } from '../flash/events';
import { SVGSprite } from '../flash/display';
import { MultipleLoader } from '../flash/net';
import { Defines } from '.';

/*
 * SVGアイテムの定義やマスタデータの管理
 * 基本となるルートSpriteの生成・管理もこちらで行う
 * (外部で勝手に行わない事)
 */
export default class Master extends EventDispatcher {
  /*
   * アイテムIDリスト
   */
  public static get itemList(): Array<string> {
    return Master._instance._itemList;
  }

  /*
   * アイテムコンテナ用SVGSprite
   */
  public static get itemContainer(): SVGSprite {
    return Master._instance._itemContainer;
  }

  private static _instance: Master;

  private _itemContainer: SVGSprite;

  private _itemSVG: any;

  private _itemList: Array<string>;

  private testName: string;

  private initializeCallBack: Function;

  private initializeCallBackScope: any;

  private itemList: Element[];

  private _itemListEqu: Array<string>;

  private _itemListFur: Array<string>;

  private _itemListExt: Array<string>;

  constructor() {
    super();
    this.testName = 'myMaster';
  }

  /*
   * 初期化
   */
  public static initialize(callback: Function, scope: any): void {
    Master._instance = new Master();

    Master._instance.initializeCallBack = callback;
    Master._instance.initializeCallBackScope = scope;

    Master._instance._itemList = [];
    Master._instance._itemSVG = {};
    Master._instance._itemContainer = new SVGSprite(document.querySelector(Defines.SVG_ITEM_CONTAINER));

    Master._instance._itemListEqu = [];
    Master._instance._itemListFur = [];
    Master._instance._itemListExt = [];

    // URLLoaderテスト
    const loader: MultipleLoader = new MultipleLoader();
    loader.addRequestURL([`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/list.xml`]);
    loader.addEventListener(Event.COMPLETE, Master._instance.completeHandler, Master._instance);
    loader.load();
  }

  public static get itemListEqu(): Array<string> {
    return Master._instance._itemListEqu;
  }

  public static get itemListFur(): Array<string> {
    return Master._instance._itemListFur;
  }

  public static get itemListExt(): Array<string> {
    return Master._instance._itemListExt;
  }

  public static getItemSvg(itemId: string): SVGElement {
    if (Master._instance._itemSVG[itemId] === undefined) {
      return null;
    }

    return (Master._instance._itemSVG[itemId] as SVGElement).cloneNode(true) as SVGElement;

    // return $(Master._instance._itemSVG[itemId]).clone();
  }

  private completeHandler(e: Event): void {
    let loader: MultipleLoader = (e.target as MultipleLoader);
    // console.log('>>>>', loader.textRequests[`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/list.xml`]);
    // const list2: JQuery = $(loader.textRequests[`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/list.xml`]).children();

    const parser: DOMParser = new DOMParser();
    const list: Element[] = Array.from(parser.parseFromString(loader.textRequests[`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/list.xml`], 'text/xml').querySelectorAll('item'));

    // console.log('list/list2', list, list2);
    // console.log('list/list2 LENGTH', list.length, list2.length);

    loader = new MultipleLoader();
    loader.addEventListener(Event.COMPLETE, Master._instance.completeHandler2, Master._instance);

    const a: string[] = [];

    for (let i: number = 0, ln: number = list.length; i < ln; i += 1) {
      const pass: string = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/items/${list[i].getAttribute('id')}.svg`;
      a[i] = pass;
    }

    this.itemList = list;

    loader.isParallel = true;
    loader.addRequestURL(a);
    loader.load();
  }

  private completeHandler2(e: Event): void {
    const loader: MultipleLoader = (e.target as MultipleLoader);

    for (let i: number = 0, ln: number = this.itemList.length; i < ln; i += 1) {
      const id: string = this.itemList[i].getAttribute('id');
      const pass: string = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}item/items/${id}.svg`;

      const tempEl = document.createElement('div');
      tempEl.innerHTML = loader.textRequests[pass];

      const svg: Element = tempEl.firstChild as Element;

      const item: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      // const item: JQuery = $('<svg></svg>');
      item.setAttribute('itemId', id);
      Master._instance._itemList.push(id);

      const g: SVGGElement[] = Array.from(svg.querySelectorAll(`g.g_${id}`));
      const defs: SVGDefsElement[] = Array.from(svg.querySelectorAll(`defs.defs_${id}`));

      if (defs.length > 0) {
        // const defines: JQuery = defs.children();
        const defineContainer:SVGGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        // const defineContainer = $('<g></g>');
        defineContainer.classList.add(`defs_${id}`);

        for (let j: number = 0, ln2: number = defs.length; j < ln2; j += 1) {
          // const define: JQuery = defines.eq(j);
          defineContainer.appendChild(defs[i]);
        }

        item.append(defineContainer);
      }

      if (g.length > 0) {
        for (let j:number = 0; j < g.length; j += 1) {
          item.appendChild(g[j]);
        }
      }

      if (id.indexOf('equ') >= 0) {
        Master._instance._itemListEqu.push(id);
      } else if (id.indexOf('fur') >= 0) {
        Master._instance._itemListFur.push(id);
      } else if (id.indexOf('ext') >= 0) {
        Master._instance._itemListExt.push(id);
      }

      Master._instance._itemSVG[id] = item;
    }

    this.calcItemSize();

    // 初期化完了したのでコールバック実行
    Master._instance.initializeCallBack.call(Master._instance.initializeCallBackScope);
    Master._instance.initializeCallBack = null;
    Master._instance.initializeCallBackScope = null;
  }

  private calcItemSize(): void {
    for (let i: number = 0; i < this._itemList.length; i += 1) {
      const itemId: string = Master.itemList[i];
      const svg: SVGElement = Master.getItemSvg(itemId);
      const spt: SVGSprite = new SVGSprite(svg);

      const rectObj: any = Master.itemContainer.initializeAddChild(spt);
      const rect: DOMRect = rectObj.root;
      const width: number = rect.right - rect.left;
      const height: number = rect.bottom - rect.top;

      // Debugger.log(itemId + ' -> ' + width + ' / ' + height);

      const original: SVGElement = Master._instance._itemSVG[itemId] as SVGElement;
      original.setAttribute('defaultWidth', Math.floor(width).toString());
      original.setAttribute('defaultHeight', Math.floor(height).toString());

      Object.keys(rectObj).forEach((prop) => {
        const crect: DOMRect = rectObj[prop];
        const cwidth: number = crect.right - crect.left;
        const cheight: number = crect.bottom - crect.top;

        const child: Element = original.querySelector(`[name='${prop}']`);

        if (child) {
          // console.log('...', prop, child);
          child.setAttribute('defaultWidth', Math.floor(cwidth).toString());
          child.setAttribute('defaultHeight', Math.floor(cheight).toString());
        }
      });
    }
  }
}
